<template>
  <div class="animated fadeIn" style="height:100%; width:auto;">
    <b-card>
      <div slot="header">
        {{this.$route.meta.title}}
        <div class="card-header-actions">
          <button
            class="btn btn-primary mr-1"
            v-b-tooltip.hover
            title="Simpan data request RRD."
            @click="save()"
          >
            <i class="fa fa-floppy-o"></i> {{ $t("save") }}
          </button>
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="10">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No. Agreement</label>
                </b-input-group-prepend>
                <b-form-input
                  readonly
                  v-model="model.no_agreement"
                  @keyup.13.native="lkuPinjamanShow=true"
                  :state="!$v.model.pinjamankey.$error"
                ></b-form-input>
                <b-input-group-append v-if="!isdetail">
                  <b-btn text="Button" @click="lkuPinjamanShow=true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:100px">No. Kontrak</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.no_kontrak" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Debitur Name</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.CustName" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
               <b-input-group>
                <b-input-group-prepend>
                  <label>Debitur No. (CIF)</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.CustCode" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
           <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Tenor</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.tenor" readonly class="text-right"></b-form-input>
                <b-input-group-prepend><span class="input-group-text" style="width:70px;">Bulan</span></b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col lg="6">
               <b-input-group>
                <b-input-group-prepend>
                  <label>Go Live - Maturity Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.startdate_frmt" readonly></b-form-input>
                <b-input-group-prepend><span class="input-group-text">-</span></b-input-group-prepend>
                    <b-form-input v-model="model.duedate_frmt" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
           <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Effective Rate (%)</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.bunga_tarifthn" readonly class="text-right"></b-form-input>
                <b-input-group-prepend><span class="input-group-text" style="width:70px;">%</span></b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Virtual Account No</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.vanumber" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Penggunaan</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.purpose_of_fin_name" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Cessie Group</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.pjxname" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Branch</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.branch" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>LDSK</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.LDSK" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>RRD Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.rrd_dt_frmt" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Expired Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.expired_date_frmt" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

        </b-col>
      </b-row>
      <hr />
      
      <b-row>
        <b-col lg="12">

          <b-input-group>
            <b-input-group-prepend>
              <label>Request Date</label>
            </b-input-group-prepend>
            <b-input type="date" v-model="model.requestdate" :state="!$v.model.requestdate.$error" />
          </b-input-group>

          <b-row>
              <b-col md="5">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Request By</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.requestby" disabled></b-form-input>
                </b-input-group>
              </b-col>
          </b-row >
          <b-row>
              <b-col md="5">
                  <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:140px;">Release to</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.releaseto" :state="!$v.model.releaseto.$error"></b-form-input>
                </b-input-group>
              </b-col>
          </b-row >
          <b-input-group>
            <b-input-group-prepend>
              <label>Keterangan</label>
            </b-input-group-prepend>
            <b-form-textarea
              v-model="model.uraian"
              placeholder=""
              rows="5"
              max-rows="10"
            ></b-form-textarea>
          </b-input-group>
        </b-col>
      </b-row>

      <hr />
      <b-table
        sticky-header 
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size:smaller;max-height:500px !important;"
        :items="tblDataOthLoan.items"
        :fields="tblFieldsOthLoan"
        :current-page="tblDataOthLoan.page"
        :per-page="tblDataOthLoan.limit"
        :sort-by.sync="tblDataOthLoan.sortBy"
        :sort-desc.sync="tblDataOthLoan.sortDesc"
        :key="tblDataOthLoan.limit"
        :busy="isBusyTblAngsuran"
        :filter="filter"
        :filterIncludedFields="filterOn"
        @filtered="onFiltered"
        show-empty
        caption-top
      >
      <template #table-caption><h5>Daftar Pinjaman Lain Sudah RRD Belum Expired</h5></template>
      <template v-slot:cell(ischecked)="data">
        <input 
            name="selectjaminan" 
            type="checkbox"
            class="mt-0"
            style="transform: scale(1.5);"
            @change="checkedothloan($event,data.item)"
            :data-pinjamankey="data.item.pinjamankey"
            :checked="ischeckedothloan(data.item.pinjamankey)"
        />
      </template>
      
      <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
        
      <template v-slot:cell(duedate)="data">{{data.item.duedate | moment("DD/MM/YY")}}</template>
      <template v-slot:cell(rrd_dt)="data">{{data.item.rrd_dt | moment("DD/MM/YY")}}</template>

        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>

      <hr />
      <b-table
        sticky-header 
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size:smaller;max-height:500px !important;"
        :items="tblDataAsset.items"
        :fields="tblFieldsAsset"
        :current-page="tblDataAsset.page"
        :per-page="tblDataAsset.limit"
        :sort-by.sync="tblDataAsset.sortBy"
        :sort-desc.sync="tblDataAsset.sortDesc"
        :key="tblDataAsset.limit"
        :busy="isBusyTblAngsuran"
        :filter="filter"
        :filterIncludedFields="filterOn"
        @filtered="onFiltered"
        show-empty
        caption-top
      >
      <template #table-caption><h5>Daftar Jaminan</h5></template>
      <template v-slot:cell(ischecked)="data">
        <input 
            name="selectjaminan" 
            type="checkbox"
            class="mt-0"
            style="transform: scale(1.5);"
            @change="checkedjaminan($event,data.item)"
            :data-jaminankey="data.item.jaminankey"
            :data-no_jaminan="data.item.no_jaminan"
            :data-isLunas="data.item.isLunas"
            :data-note="data.item.note"
            :checked="ischeckedjaminan([data.item.jaminankey, data.item.ischecked])"
        />
      </template>
      
      <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>

      <template v-slot:cell(no_jaminan)="data">
        <span :class="data.item.note!=''?'bg-warning text-dark p-2':''">
          {{data.item.no_jaminan}}
        </span>  
      </template>

        <template v-slot:cell(nilaijaminan)="data">{{
          data.item.nilaijaminan | numFormat('0,0.00')
        }}</template>
        <template v-slot:cell(alamat)="data">
          {{ data.item.alamat || "-" }}
          <br />
          Kelurahan : {{ data.item.kelurahan }} - Kecamatan :{{
            data.item.kecamatan
          }}
          <br />
          Kota : {{ data.item.kota }} - Provinsi :{{ data.item.provinsi }}
          <br />
          Kode Pos : {{ data.item.kodepos }}
        </template>
        <template v-slot:cell(detail)="data">
          <span v-if="data.item.tipejaminan == 'Kendaraan'">
            <b-row>
              <b-col md="6">- No. BPKB : {{ data.item.bpkb }}</b-col>
              <b-col md="6">- No. STNK : {{ data.item.stnk }}</b-col>
            </b-row>
            <b-row>
              <b-col md="6">- Status STNK : {{ data.item.statusstnk }}</b-col>
              <b-col md="6"
                >- Tanggal STNK :
                {{ data.item.tanggalstnk | moment("DD/MM/YY") }}</b-col
              >
            </b-row>
          </span>
          <span v-else>
            <b-row>
              <b-col md="6">
                - Luas Tanah : {{ data.item.luastanah }} m
                <sup>2</sup>
              </b-col>
              <b-col md="6">
                - Luas Bangunan : {{ data.item.luasbangunan }} m
                <sup>2</sup>
              </b-col>
            </b-row>
            - Status Sertifikat : {{ data.item.sertifikatstatus }}
            <span v-if="data.item.sertifikatstatus === 'lainnya'"
              >- {{ data.item.otherstatussertifikat }}</span
            >
            <b-row>
              <b-col md="6"
                >- No Sertifikat : {{ data.item.sertifikatno }}</b-col
              >
              <b-col md="6"
                >- Sertifikat Atas Nama : {{ data.item.pemilikjaminan }}</b-col
              >
            </b-row>
            <b-row>
              <b-col md="6">- Status PBB : {{ data.item.statuspbb }}</b-col>
              <b-col md="6">- Tanggal PBB: {{ data.item.tanggalpbb }}</b-col>
            </b-row>
            <b-row>
              <b-col md="6"
                >- Status Asuransi : {{ data.item.statusasuransi }}</b-col
              >
              <b-col md="6">- No. IMB : {{ data.item.noimb }}</b-col>
            </b-row>
          </span>
        </template>
        <template v-slot:cell(tgl_kontrak)="data">{{
          data.item.tgl_kontrak | moment("DD/MM/YY")
        }}</template>

        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div align="left">
            Showing {{(tblDataAsset.page - 1) * tblDataAsset.limit + 1}}
            to
            <span
              v-if="((tblDataAsset.page * tblDataAsset.limit)>tblDataAsset.total)"
            >{{tblDataAsset.total}}</span>
            <span v-else>{{tblDataAsset.page * tblDataAsset.limit}}</span>
            of {{tblDataAsset.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label style="margin-top:0 !important;">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25,50,75,100]"
                  :plain="true"
                  v-model="tblDataAsset.limit"
                  size="sm"
                  style="width:80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblDataAsset.total"
            :per-page="tblDataAsset.limit"
            v-model="tblDataAsset.page"
            @click="getAssetData()"
          ></b-pagination>
        </b-col>
      </b-row>

      <div slot="footer">
        <div class="card-footer-actions text-center">
          <button
            class="btn btn-primary mr-1"
            v-b-tooltip.hover
            title="Simpan data request RRD."
            @click="save()"
          >
            <i class="fa fa-floppy-o"></i> {{ $t("save") }}
          </button>
          <button
            class="btn btn-primary mr-1"
            v-b-tooltip.hover
            title
            @click="close()"
          >
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>

    </b-card>
    <b-modal
      v-model="lkuPinjamanShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Pinjaman"
      :centered="true"
    >
      <lku-pinjaman @click="onSelectLkuPinjaman" :modelpinjaman="model.model_pinjaman"></lku-pinjaman>
    </b-modal>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>   
  </div>
</template>

<style lang="scss" scoped>
  .table-red-text{
    color:red;
  }
</style>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import Loading from 'vue-loading-overlay';

import myNumber from "../../components/my-number";
import lkuPinjaman from "./lkuPinjaman";
import pinjaman from "../../apis/pinjamankredit";
import asset from "../../apis/agunankredit";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading, myNumber, lkuPinjaman },
  mixins: [validationMixin],
  validations: {
    model: {
      pinjamankey: { required },
      requestdate: { required },
      // tiperelease: { required },
      releaseto: { required },
      selected: { required }
    },
  },
  data() {
    return {
      showReport:false,
      reportUrl:null,
      isLoading:false,
      tabIndex:0,
      model: { requestkey:"",pinjamankey: "",requestdate:"",releaseto: "",paketpengirim:"",noresi:"",selected: [],printall:1,
      next_installment_no:0,
      next_installment_date:'',
      next_installment_due_no:0,
      next_installment_due_date:'',
      principal_outstand_undue:0,
      interest_outstand_undue:0
      },
      lkuPinjamanShow: false,
      tblDataAsset: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "jaminankey",
        sortDesc: false,
        pemilikjaminan: null,
        lokasijaminan: null,
        nilai1: 0,
        nilai2: 0,
        no_kontrak: null,
        tipejaminan: "",
        statusasuransi: "",
        jaminankeys: [],
        sourceproject: this.$store.state.user.compcode||"",
      },
      isdetail: false,
      isBusyTblAngsuran: false,
      filter: "",
      filterOn: ["statuspay"],

      optReleaseTo: [
        { value: "", text: "-- SELECT ONE --" },
        { value: "self", text: "Diambil Sendiri oleh Debitur" },
        { value: "package", text: "Kirim via Paket" },
      ],

      tblDataOthLoan: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "jaminankey",
        sortDesc: false,
        pemilikjaminan: null,
        lokasijaminan: null,
        nilai1: 0,
        nilai2: 0,
        no_kontrak: null,
        tipejaminan: "",
        statusasuransi: "",
        jaminankeys: [],
        sourceproject: this.$store.state.user.compcode||"",
        selected:[]
      },

    };
  },
  props: ["modelpinjaman"],
  computed: {
    ifPaket() {
      return this.model.tiperelease == "package" ? true : false;
    },
    tblFieldsAsset() {
      const fields = [
        { key: "ischecked", label: "Checked" },
        { key: "index", label: "No." },
        {
          key: "no_jaminan",
          label: "No Jaminan",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "namajaminan",
          label: "Nama Jaminan",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "tipejaminan",
          label: "Tipe Jaminan",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "nilaijaminan",
          label: "Nilai Jaminan",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "pemilikjaminan",
          label: "Pemilik Jaminan",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "alamat",
          label: "Alamat",
          thClass: "text-center",
          thStyle: "width:1500px",
          sortable: true,
        },
        {
          key: "detail",
          label: "Detail",
          thClass: "text-center",
          thStyle: "width:2000px",
          sortable: true,
        },
        {
          key: "note",
          label: "Note",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:200px",
          sortable: true,
        },
      ];
      return fields;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
     tblFieldsOthLoan() {
      const fields = [
        { key: "ischecked", label: "Checked" },
        { key: "index", label: "No." },
        {
          key: "no_agreement",
          label: "No Agreement",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "no_kontrak",
          label: "No. Kontrak",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "CustCode",
          label: "Debitur No. (CIF)",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "CustName",
          label: "Debitur Name",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "duedate",
          label: "Maturity Date",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "rrd_dt",
          label: "RRD Date",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:500px",
          sortable: true,
        }
      ];
      return fields;
    },
  },

  beforeUpdate: function () {},
  created: async function () {

    if (this.$route.params.requestkey) {
      this.model.requestkey = this.$route.params.requestkey;
      this.model.pinjamankey = this.$route.params.pinjamankey;
      this.isdetail = true;
      try {
        this.isLoading = true;
        const requestkey = this.model.requestkey;
        const data = await pinjaman.detailrequestedit(requestkey);
        const dtheader = data[0][0];
        for (const key in dtheader) {
          if (dtheader.hasOwnProperty(key)) {
            this.model[key] = dtheader[key];
          }
        }
        this.tblDataOthLoan.selected = dtheader.othloan ? dtheader.othloan.split(",") : "";

        this.model.requestdate = this.model.requestdate ? moment(this.model.requestdate).format("YYYY-MM-DD") : "";
        this.model.tgl_kontrak = this.model.tgl_kontrak ? moment(this.model.tgl_kontrak).format("YYYY-MM-DD") : "";
        this.model.startdate_frmt = this.model.startdate ? moment(this.model.startdate).format('DD-MM-YYYY') : "";
        this.model.duedate_frmt = this.model.duedate ? moment(this.model.duedate).format('DD-MM-YYYY') : "";
        this.model.rrd_dt_frmt = this.model.rrd_dt ? moment(this.model.rrd_dt).format('DD-MM-YYYY') : "";
        this.model.expired_date_frmt = this.model.expired_date ? moment(this.model.expired_date).format('DD-MM-YYYY') : "";
        this.model.next_installment_date= this.model.next_installment_date ? moment(this.model.next_installment_date).format('DD-MM-YYYY') : "";
        this.model.next_installment_due_date= this.model.next_installment_due_date ? moment(this.model.next_installment_due_date).format('DD-MM-YYYY') : "";

        const dtasset = data[1];
        this.tblDataAsset.items=dtasset;
        this.tblDataAsset.total = dtasset.length;
        
        for (const key in dtasset) {
          if (dtasset.hasOwnProperty(key)) {
            this.model.selected.push({
            jaminankey: dtasset[key].jaminankey,
            ischecked: dtasset[key].ischecked === 1 ? true : false
          });
          }
        }

        const dtotherloan = data[2];
        this.tblDataOthLoan.items=dtotherloan;
        this.tblDataOthLoan.total = dtotherloan.length;

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }

    } else {
      if (this.$route.params.pinjamankey) {
        this.model.pinjamankey = this.$route.params.pinjamankey;
        this.isdetail = true;
        try {
          this.isLoading = true;
          const pinjamankey = this.model.pinjamankey;
          
          const data = await pinjaman.detailrequest(pinjamankey);
          
          const dtpinjaman = data[0][0][0];
          for (const key in dtpinjaman) {
            if (dtpinjaman.hasOwnProperty(key)) {
              this.model[key] = dtpinjaman[key];
            }
          }
          this.model.tgl_kontrak = this.model.tgl_kontrak ? moment(this.model.tgl_kontrak).format("YYYY-MM-DD") : "";
          this.model.startdate_frmt = this.model.startdate ? moment(this.model.startdate).format('DD-MM-YYYY') : "";
          this.model.duedate_frmt = this.model.duedate ? moment(this.model.duedate).format('DD-MM-YYYY') : "";
          this.model.rrd_dt_frmt = this.model.rrd_dt ? moment(this.model.rrd_dt).format('DD-MM-YYYY') : "";
          this.model.expired_date_frmt = this.model.expired_date ? moment(this.model.expired_date).format('DD-MM-YYYY') : "";
          this.model.next_installment_date= this.model.next_installment_date ? moment(this.model.next_installment_date).format('DD-MM-YYYY') : "";
          this.model.next_installment_due_date= this.model.next_installment_due_date ? moment(this.model.next_installment_due_date).format('DD-MM-YYYY') : "";
          
          const dtasset = data[0][1];
          this.tblDataAsset.items=dtasset;
          this.tblDataAsset.total = dtasset.length;

          const dtotherloan = data[0][2];
          this.tblDataOthLoan.items=dtotherloan;
          this.tblDataOthLoan.total = dtotherloan.length;

          const dtRequestCurr = await pinjaman.requestCurr();
          this.model.requestno = dtRequestCurr ? dtRequestCurr : "";
          this.model.requestby = `${this.$store.state.user.full_name ? this.$store.state.user.full_name : ""} | ${this.$store.state.user.jabatan ? this.$store.state.user.jabatan : ""}`;
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          console.log("error : ", error);
          toastr.error(JSON.stringify(error), "ERROR MESSAGE");
        } 
      }
    }
    this.model.releaseto = this.model.releaseto ? this.model.releaseto : this.model.CustName;
  },
  watch:{},
  methods: {
    rowClass(item, type) {
      const today = moment().format('YYYY-MM-DD');
        if ((item && item.outstand_bunga ||0)>0.009 || (item && item.outstand_pokok||0) > 0.009) {
          if(moment(today).diff(moment(item.tgl_jttempo),'days')>-1){
            return 'text-danger';
          }else{
            return '';
          }
            
        }else{
          return '';
        }
        
      },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    onSelectLkuPinjaman(_selected) {
      this.model.pinjamankey = _selected.pinjamankey;

       this.tblDataPayment= {
            page: 1,
            limit: 50,
            total: 0,
            tgl1: '',
            tgl2: '',
            sortBy: "tglpaym",
            sortDesc: true,
            pinjamankey:'',
            items:[]
          },
          this.tabIndex=0;

      this.getData();
      this.lkuPinjamanShow = false;
    },

    ischeckedjaminan(val){
      const findjaminan = this.model.selected.find(x => ((x.jaminankey === val[0]) && (x.ischecked === true) ));
      if(findjaminan){
        return 'checked'
      }else{
        return '';
      }
    },

    checkedjaminan(item,record) {
      const jaminankey = item.target.attributes["data-jaminankey"].value;
      if (item.target.checked === true) {
        const findCheck = this.model.selected.find(x => ((x.jaminankey === jaminankey)));
        if (!(findCheck)){
          this.model.selected.push({
            jaminankey,
            ischecked: item.target.checked
          });
        }else{
          this.model.selected.splice(findCheck, 1);
          this.model.selected.push({
            jaminankey,
            ischecked: item.target.checked
          });
        }
      } else {
        const findIdx = this.model.selected.findIndex(x => ((x.jaminankey === jaminankey)));
        this.model.selected.splice(findIdx, 1);
      }
      //console.log("### this.model.selected: ", this.model.selected);
    },

    ischeckedothloan(pinjamankey){
      const findjaminan = this.tblDataOthLoan.selected.find(x => x === pinjamankey);
      if(findjaminan){
        return 'checked'
      }else{
        return '';
      }
    },

    checkedothloan(item,record) {
      const pinjamankey = item.target.attributes["data-pinjamankey"].value;
      if (item.target.checked === true) {
        const findCheck = this.tblDataOthLoan.selected.find(x => ((x == pinjamankey)));
        if (!(findCheck)){
          this.tblDataOthLoan.selected.push(pinjamankey);
        }else{
          this.tblDataOthLoan.selected.splice(findCheck, 1);
        }
      } else {
        const findIdx = this.tblDataOthLoan.selected.findIndex(x => ((x === pinjamankey)));
        this.tblDataOthLoan.selected.splice(findIdx, 1);
      }
    },

    integer_to_roman(num) {
      if (typeof num !== 'number') 
      return false; 

      var digits = String(+num).split(""),
      key = ["","C","CC","CCC","CD","D","DC","DCC","DCCC","CM",
      "","X","XX","XXX","XL","L","LX","LXX","LXXX","XC",
      "","I","II","III","IV","V","VI","VII","VIII","IX"],
      roman_num = "",
      i = 3;
      while (i--)
      roman_num = (key[+digits.pop() + (i * 10)] || "") + roman_num;
      return Array(+digits.join("") + 1).join("M") + roman_num;
    },

    async save() {
      if(this.invalidModel){
        if (this.$v.model.$model.requestdate && this.$v.model.$model.releaseto && this.$v.model.$model.selected && this.$v.model.$model.selected.length === 0) {
          toastr.error("Please checked jaminan first!", "ERROR MESSAGE");
        }else{
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        }
      }else {
          this.model.othloan = this.tblDataOthLoan.selected;
          await pinjaman.saveRequest(this.model);
          toastr.success("Request RRD berhasil disimpan");
          router.push({ name: "loan.pelepasandokumen" });
      }
    },

    close() {
      router.push({ name: "loan.pelepasandokumen" });
    },
    async getData() {
    },
    async getAssetData(){
    },
  },
};
</script>